import { Controller } from 'react-hook-form';
import {
  InputSize,
  InputText,
  Select,
  SelectSize,
  SelectType,
  Textarea,
} from '@ui/src';
import AdditionalInfoBlock from '../../../individual/aml/additional-info-block';
import RegulatedCompanyRow from './row';
import { CustomersWealthTypes } from './types';
import { CustomerStatus } from '../../../../hoc/customers/types';
import AnnualIncomes from './annual-incomes';

import cn from './styles.module.css';

const CustomersWealth = ({
  control,
  clearErrors,
  setValue,
  status,
  errors,
  fields,
  customerSourceOfWealth,
  baseCurrency,
  annualIncomes,
  totalIncomeError,
  setTotalIncomeError,
}: CustomersWealthTypes) => (
  <AdditionalInfoBlock title="Customer's wealth">
    <>
      <RegulatedCompanyRow title="Source of the Customer's wealth (total assets)">
        <Controller
          control={control}
          name="sourceOfWealthIds"
          defaultValue={[]}
          render={({ field: { onChange, value, name } }) => (
            <Select
              name={name}
              placeholder="Select an option..."
              list={
                customerSourceOfWealth?.map((item) => ({
                  name: item.value,
                  value: item.id,
                })) || []
              }
              value={value}
              size={SelectSize.SMALL}
              onChange={(e) => {
                onChange(e);
                clearErrors(['sourceOfWealthIds']);

                if (
                  !(e.target.value as string[])?.includes('Other') &&
                  fields?.sourceOfWealthOther
                ) {
                  clearErrors(['sourceOfWealthOther']);
                  setValue('sourceOfWealthOther', '');
                }
              }}
              selectWrapperClassName={
                status === CustomerStatus.CLOSED ? cn.selectDisabled : ''
              }
              disabled={status === CustomerStatus.CLOSED}
              tabIndex={status === CustomerStatus.CLOSED ? -1 : 0}
              error={errors?.sourceOfWealthIds?.message}
              mode={SelectType.MULTIPLE}
              fullWidth
              borderless
            />
          )}
        />
      </RegulatedCompanyRow>
      {fields?.sourceOfWealthIds?.find((item) =>
        customerSourceOfWealth
          ?.find((client) => item === client.id)
          ?.value?.includes('Other'),
      ) && (
        <RegulatedCompanyRow title="Provide details">
          <Controller
            control={control}
            name="sourceOfWealthOther"
            defaultValue=""
            render={({ field: { onChange, value, name } }) => (
              <Textarea
                name={name}
                title=""
                placeholder="Enter details..."
                value={value}
                onChange={(e) => {
                  onChange(e);
                  clearErrors(['sourceOfWealthOther']);
                }}
                className={`borderless ${cn.pepTextarea} ${cn.stepOneTextarea}`}
                error={errors?.sourceOfWealthOther?.message}
                disabled={status === CustomerStatus.CLOSED}
                tabIndex={status === CustomerStatus.CLOSED ? -1 : 0}
              />
            )}
          />
        </RegulatedCompanyRow>
      )}
      <RegulatedCompanyRow
        title={`Estimated total wealth (${baseCurrency?.name})`}
      >
        <Controller
          control={control}
          name="estimatedTotalWealth"
          defaultValue=""
          render={({ field: { onChange, value, name } }) => (
            <InputText
              name={name}
              placeholder="Enter amount..."
              value={value}
              size={InputSize.SMALL}
              onChange={(e) => {
                onChange(e);
                clearErrors(['estimatedTotalWealth']);
              }}
              className="borderless"
              disabled={status === CustomerStatus.CLOSED}
              tabIndex={status === CustomerStatus.CLOSED ? -1 : 0}
              error={errors?.estimatedTotalWealth?.message}
              currency={baseCurrency}
              amountInput
            />
          )}
        />
      </RegulatedCompanyRow>
      <RegulatedCompanyRow title={`Annual income (${baseCurrency?.name})`}>
        <Controller
          control={control}
          name="annualIncome"
          defaultValue=""
          render={({ field: { onChange, value, name } }) => (
            <InputText
              name={name}
              placeholder="Enter amount..."
              value={value}
              size={InputSize.SMALL}
              onChange={(e) => {
                onChange(e);
                clearErrors(['annualIncome']);
              }}
              className="borderless"
              disabled={status === CustomerStatus.CLOSED}
              tabIndex={status === CustomerStatus.CLOSED ? -1 : 0}
              error={errors?.annualIncome?.message}
              currency={baseCurrency}
              amountInput
            />
          )}
        />
      </RegulatedCompanyRow>
      <AnnualIncomes
        annualIncomes={annualIncomes}
        fields={fields}
        setTotalIncomeError={setTotalIncomeError}
        clearErrors={clearErrors}
        setValue={setValue}
        totalIncomeError={totalIncomeError}
        errors={errors}
        control={control}
        status={status}
      />
    </>
  </AdditionalInfoBlock>
);

export default CustomersWealth;
